import * as React from 'react';
import * as ReactDOM from 'react-dom';

import { Trans } from '@lingui/macro';

// Shared
import Backdrop from '../../../../../../shared/backdropModal';

const modalPortalRoot = document.getElementById('modal-portal-root');

export default class CompleteModal extends React.Component<
  {
    onContinue: any;
    onCancel: any;
  },
  {}
> {
  el;

  constructor(props) {
    super(props);

    this.el = document.createElement('div');
  }

  componentDidMount = () => {
    modalPortalRoot.appendChild(this.el);
  };

  componentWillUnmount = () => {
    modalPortalRoot.removeChild(this.el);
  };

  render() {
    const content = (
      <Backdrop>
        <div className="pop-up-wrapper">
          <div className="pop-up-container">
            <h6 className="ml-3">
              <Trans>Veuillez compléter votre profil</Trans>
            </h6>
            <div className="flex v-align">
              <div className="col v-align align-center text-center">
                <img src="/images/icon.svg" alt="" className="anonymous-icon" width="100" />
                <p>
                  <Trans>
                    Cet employeur n’accepte que les candidats <br />
                    avec un profil complet
                  </Trans>
                </p>
              </div>
            </div>
            <div className="profile-card-buttons-wrapper">
              <div className="profile-card-buttons-cotnainer">
                <a
                  href="#"
                  onClick={this.props.onCancel}
                  className="button outline left-cap grey w-inline-block">
                  <img
                    src="/images/Cancel.svg"
                    width="24"
                    alt=""
                    className="icon-button-profile-card"
                  />
                  &nbsp;<Trans>Annuler</Trans>
                </a>
                <a
                  href="#"
                  onClick={this.props.onContinue}
                  className="button solid right-cap color-accent-1 w-inline-block">
                  <img
                    src="/images/check.svg"
                    width="24"
                    alt=""
                    className="icon-button-profile-card"
                  />
                  &nbsp;<Trans>OK</Trans>
                </a>
              </div>
            </div>
          </div>
        </div>
      </Backdrop>
    );

    return ReactDOM.createPortal(content, this.el);
  }
}
